// extracted by mini-css-extract-plugin
module.exports = {"card":"_1X3Cw","active":"_2GMt3","landingLeadFormCard":"_10odn"};